import { useEffect } from 'react';
import { useAppDependencyGraphProvider } from '../../../../context/DependencyGraphProvider';
import { ComputeContextKeys } from '../../../../hooks/computeContext/const';
import { useGlobalAppStateStore } from '../../../../stores/app/GlobalAppStateStore';
import type { ColorSchemeDetails } from '../../../../stores/app/GlobalAppStateStore/types';

export function useChangeInitialColorSchemeDetails(initalColorSchemeDetails?: ColorSchemeDetails) {
  const { setColorSchemeDetails } = useGlobalAppStateStore().hooks.useActions();

  const {
    actions: { notifyDependencyChange },
  } = useAppDependencyGraphProvider();

  useEffect(() => {
    if (!initalColorSchemeDetails) {
      return;
    }
    setColorSchemeDetails(initalColorSchemeDetails);

    notifyDependencyChange({
      id: ComputeContextKeys.THEME,
    });
  }, [notifyDependencyChange, initalColorSchemeDetails, setColorSchemeDetails]);
}
